import { render, staticRenderFns } from "./receiveMenu.vue?vue&type=template&id=c792e4a8&scoped=true"
import script from "./receiveMenu.vue?vue&type=script&lang=js"
export * from "./receiveMenu.vue?vue&type=script&lang=js"
import style0 from "./receiveMenu.vue?vue&type=style&index=0&id=c792e4a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c792e4a8",
  null
  
)

export default component.exports